

export default require('./FinishedProductsCss.module.scss');
